import { atom } from "jotai";

export const searchAtom = atom<string>();
export const usernameAtom = atom<string>();
export const categoryAtom = atom<string>("hot_games");
export const providerAtom = atom<string>("jilislot");
export const inSessionAtom = atom<boolean>(false);
export const ipAddressAtom = atom<string>("127.0.0.1");
export const oneSignalIDAtom = atom<string>();
